export enum LocaleSource {
    Default = 0,
    DomainName,
    UserAgent,
    UserSettings
}
